import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ProgressSpinner
  from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import ErrorBanner from '@avtechsoftware/react-component-library/src/components/common/ErrorBanner';
import axios from 'axios';
import envConfig from '../../../envConfig';
import RaApiOrderMapperV1 from '../../../classes/mappers/orders/RaApiOrderMapperV1';
import OrderDetails from '../../orders/OrderDetails/OrderDetails';
import { getResourceIdFromURLParam } from '../../../utility/orderAndQuoteUtil';
import {
  publicContextPropType,
  withPublicContext,
} from '../../../contexts/PublicContext/PublicContext';

class PublicOrderPaymentPage extends React.Component {
  constructor(props) {
    super(props);
    const { id } = props.match.params;
    const parsedId = getResourceIdFromURLParam(id);
    this.state = {
      order: { orderNumber: `ORD-${parsedId}` },
      loading: true,
      loadError: false,
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    const { match } = this.props;
    const { id } = match.params;
    const parsedId = getResourceIdFromURLParam(id);
    const validationId = id.split('-')[2];

    this.setState({ loading: true });
    return axios.get(
      `${envConfig.apiUrl}/api/v1/orders/public/${parsedId}-${validationId}`,
    ).then((orderResponse) => {
      if (orderResponse.data.success === false) {
        this.setState({
          loadError: true,
        });
      }
      const order = RaApiOrderMapperV1
        .mapJsonToOrderDetails(orderResponse.data.data.orderDetails);
      this.setState({
        order,
        loading: false,
      });
    }).catch(() => {
      this.setState({
        loadError: true,
      });
    });
  }

  onCloseError() {
    this.setState({ loadError: false });
  }

  render() {
    const {
      loading, loadError, order,
    } = this.state;
    const { publicContext } = this.props;
    const { match } = this.props;
    const { id } = match.params;
    const validationId = id.split('-')[2];
    return (
      <div className="container-fluid mt-3 overflow-hidden">
        <div className="col-12">
          {loadError && (
            <div className="row">
              <div className="col">
                <ErrorBanner onCloseError={this.onCloseError}>
                  Unexpected Error retrieving order.
                </ErrorBanner>
              </div>
            </div>
          )}
          {loading ? ((
            <div className="row d-flex justify-content-center mt-5">
              <div>
                <ProgressSpinner />
              </div>
            </div>
          ))
            : (
              <OrderDetails
                order={order}
                isPublicView
                userHasGrantAccessPrivileges={false}
                userHasShareLinkPrivileges={false}
                supportsRoles={false}
                samlEnabled={false}
                setSubscriptionSwapUrl={() => {}}
                remoteService={publicContext.remoteService}
                validationId={validationId}
              />
            )}
        </div>
      </div>
    );
  }
}

export { PublicOrderPaymentPage };

PublicOrderPaymentPage.propTypes = {
  publicContext: publicContextPropType.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) })
    .isRequired,
};

export default withRouter(withPublicContext(PublicOrderPaymentPage));
